// Welche Fassung der App läuft – und der Hinweis, wenn eine neue da ist
// (O46). Sonst testet man am iPhone womöglich einen alten Stand, ohne es zu
// merken: Die App liegt am Gerät (Service Worker) und startet zuerst so, wie
// sie beim letzten Mal war.
//
// Die Fassung ist der kurze Commit (7 Zeichen). Sie wird beim Bau eingesetzt
// (vite-app.ts, `define`), auf GitHub aus dem Commit, am Laptop „lokal“.

import { useSyncExternalStore } from "react";

declare const __FASSUNG__: string | undefined;

/** Die Fassung dieser App, z. B. „abc1234“ – am Laptop „lokal“. */
export const FASSUNG: string = typeof __FASSUNG__ === "string" && __FASSUNG__ ? __FASSUNG__ : "lokal";

// --- Neue Fassung bereit -------------------------------------------------------

let neueFassungDa = false;
const zuhoerer = new Set<() => void>();

/** Der Service Worker hat gewechselt: Beim nächsten Laden läuft die neue Fassung. */
export function neueFassungMelden(): void {
  neueFassungDa = true;
  for (const z of zuhoerer) z();
}

function abonnieren(melden: () => void): () => void {
  zuhoerer.add(melden);
  return () => zuhoerer.delete(melden);
}

/** Ein gut sichtbarer Knopf oben: „Neue Fassung – tippen zum Neuladen“. */
export function NeueFassung() {
  const da = useSyncExternalStore(
    abonnieren,
    () => neueFassungDa,
    () => false,
  );
  if (!da) return null;
  return (
    <button type="button" className="neue-fassung" onClick={() => window.location.reload()}>
      Neue Fassung – tippen zum Neuladen
    </button>
  );
}
